import { Container } from '../../ui'
import cn from 'classnames'
import {useDispatch} from "react-redux";
import {openWindow} from "../../models/window/actions";
import {modalNames} from "../common/modal/constants/names";

import c from './assets/sass/contacts.module.scss'

const Contacts = () => {
    const dispatch = useDispatch()

    const bookHandler = () => {
        dispatch(openWindow(modalNames.CONTACT_MODAL))
    }

    return (
        <section id="contacts" className={c.component}>
            <Container customMaxWidth={1160}>
                <div className={c.title}>Контакты</div>
                <div className={c.subtitle}>Мы на связи с Вами</div>
                <div className={c.info}>
                    Пожалуйста свяжитесь с нами при возникновении любых вопросов
                    и бронирования записи к мастеру
                </div>
                <ul className={c.list}>
                    <li className={cn(c.item, c.call)}>
                        <div className={c.text}>
                            <div className={c.itemTitle}>Звоните</div>
                            <div className={c.itemText}>+7 985 665-62-94</div>
                        </div>
                    </li>
                    <li className={cn(c.item, c.booking)}>
                        <div className={c.text}>
                            <div className={c.itemTitle}>Онлайн запись</div>
                            <div className={c.itemText}>+7 985 665-62-94</div>
                        </div>
                        <button className={c.itemButton} onClick={bookHandler}>Записаться</button>
                    </li>
                    <li className={cn(c.item, c.address)}>
                        <div className={c.text}>
                            <div className={c.itemTitle}>Ждём вас</div>
                            <div className={c.itemText}>
                                Мск, Казакова дом 8 стр. 2
                            </div>
                        </div>
                        <a
                            href="https://yandex.ru/maps/-/CTC7jTpU"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={cn(c.itemButton, c.addressButton)}
                        >
                            Маршрут
                        </a>
                    </li>
                </ul>
            </Container>
            <div className={c.map}>
                <a
                    className={c.marker}
                    href="https://yandex.ru/maps/-/CTC7jTpU"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className={c.markerButton}>Мы здесь</div>
                </a>
            </div>
        </section>
    )
}

export default Contacts
